import { Link } from "react-router-dom";
import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { FaTwitter, FaLinkedin, FaInstagram, FaYoutube } from "react-icons/fa";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cols = [
  {
    title: "Product",
    links: [
      { label: "Sell Online", href: "/business/sell-online" },
      { label: "Collect Payments", href: "/business/collect-payments" },
      { label: "Manage Inventory", href: "/business/manage-inventory" },
      { label: "Manage Operations", href: "/business/manage-operations" },
      { label: "Automate Orders", href: "/business/automate-orders" },
      { label: "Business Records", href: "/business/create-records" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Solopreneurs", href: "/serve/solopreneurs" },
      { label: "Medium Businesses", href: "/serve/medium" },
      { label: "Large Businesses", href: "/serve/large" },
      { label: "Enterprise", href: "/serve/enterprise" },
      { label: "Modules", href: "/modules" },
      { label: "Pricing", href: "/pricing" },
    ],
  },
  {
    title: "Partners",
    links: [
      { label: "Reseller Program", href: "/partners/reseller" },
      { label: "Referral Program", href: "/partners/referral" },
      { label: "Community", href: "/community" },
      { label: "Blog", href: "/blog" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Support", href: "/support" },
      { label: "FAQs", href: "/faqs" },
    ],
  },
];

const LEGAL = [
  { label: "Terms & Conditions", href: "/legal/terms" },
  { label: "Refund Policy", href: "/legal/refund" },
  { label: "Privacy Policy", href: "/legal/privacy" },
  { label: "Data Privacy", href: "/legal/data-privacy" },
  { label: "Cookies", href: "/legal/cookies" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Enter a valid email");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Subscribed! Check your inbox soon.");
      setEmail("");
    } catch {
      toast.error("Subscription failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#176842] text-white mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-12 gap-12">

          {/* LEFT */}
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-extrabold text-3xl">Brivo</span>
            </Link>

            <p className="mt-5 text-white/70 max-w-sm">
              The all-in-one platform that helps modern businesses sell smarter and grow without limits.
            </p>

            {/* Newsletter */}
            <form onSubmit={subscribe} className="mt-8 flex gap-2 max-w-md">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white"
              />
              <button
                disabled={loading}
                className="px-5 py-3 rounded-xl bg-[#FFF9E6] text-black font-semibold"
              >
                {loading ? "..." : "Subscribe"}
              </button>
            </form>

            {/* Social Icons */}
            <div className="flex gap-4 mt-8 text-xl">
              <FaTwitter />
              <FaLinkedin />
              <FaInstagram />
              <FaYoutube />
            </div>
          </div>

          {/* LINKS */}
          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {cols.map((col) => (
              <div key={col.title}>
                <h4 className="font-bold text-lg mb-5">{col.title}</h4>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.href}>
                      <Link
                        to={l.href}
                        className="text-white/70 hover:text-white text-sm flex items-center gap-1"
                      >
                        {l.label}
                        <ArrowUpRight size={14} />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

        </div>

        {/* FOOTER BOTTOM */}
        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col lg:flex-row justify-between">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} Brivo Inc.
          </p>

          <div className="flex gap-4 text-sm text-white/60 flex-wrap">
            {LEGAL.map((l) => (
              <Link key={l.href} to={l.href}>
                {l.label}
              </Link>
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
}